var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ffedef;}.cls-3{fill:#e95060;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Latest_Cusomers",
    "data-name": "Latest Cusomers",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_BG",
    "data-name": "Shape BG"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32,
    rx: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.9,10.6H9v1.558h7.9Zm-4.75,4.75H9V16.9h3.154v1.6h1.6V13.75h-1.6ZM15.346,16.9h7.9V15.346h-7.9ZM16.9,18.5H15.346v4.75H16.9v-1.6H23.25V20.1H16.9ZM20.1,10.6V9H18.5v4.75h1.6v-1.6H23.25V10.6ZM9,21.654h4.75V20.1H9Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.c26a882dac0c773b4b9a36843d6bb46d.svg";
export { ForwardRef as ReactComponent };